import { ContactsApiProvider } from './contactsapi.services';
import Axios from 'axios';
import { toggleReadLoader } from 'actions';
import _ from 'lodash';
import moment from 'moment';
import { appendUrlParameters } from '../utils/urlparams.service';
const CancelToken = Axios.CancelToken;
let tokenCancel;
const envResponse = Axios.get('/env_config/config.json');

export const fetchMemberOpportunities = (memberKey, baseOnly = true, embed = null, start = null, end = null) => {
  var url = appendUrlParameters(`/members/${memberKey}/opportunities`, [['baseOnly', baseOnly], ['start', start], ['end', end], ['embed', embed]]);
  return ContactsApiProvider.get(url);
};

export const fetchOpportunityByMemberKey = (memberKey, opportunityId, embed = null) => {
  var url = appendUrlParameters(`/members/${memberKey}/opportunities/${opportunityId}`, [['embed', embed]]);
  return ContactsApiProvider.get(url);
};

export const fetchContactOpportunities = (contactId, embed) => async dispatch => {
  tokenCancel && tokenCancel(`at ${moment()}`);
  const envData = await envResponse;
  try {
    dispatch(toggleReadLoader(true));
    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: `/contacts/${contactId}/opportunities?&embed=${embed}`,
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const fetchOpportunityByContactId = (contactId, opportunityId) => async dispatch => {
  tokenCancel && tokenCancel(`at ${moment()}`);
  const envData = await envResponse;
  try {
    dispatch(toggleReadLoader(true));
    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: `/contacts/${contactId}/opportunities/${opportunityId}`,
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateOpportunity = (contactId, opportunityId, opportunity) => {
  return ContactsApiProvider.put(`/contacts/${contactId}/opportunities/${opportunityId}`, opportunity);
};

export const updateOpportunityNotes = (contactId, opportunityId, payload) => {
  return ContactsApiProvider.post(`/contacts/${contactId}/opportunities/${opportunityId}/statusnotes`, payload);
};

export const fetchOpportunityDocuments = (contactId, opportunityId = null) => {
  let url = `/contacts/${contactId}/opportunities/documents`;

  if (opportunityId) {
    url = `/contacts/${contactId}/opportunities/${opportunityId}/documents/`;
  }

  return ContactsApiProvider.get(url);
};

// TODO: Move this to a separate file - systemtypes.services.js

export const fetchSystemTypes = (type, eventTypeFilter = 'MANUAL_OPPORTUNITY_STATUS_UPDATE') => async dispatch => {
  const envData = await envResponse;
  tokenCancel && tokenCancel();
  try {
    dispatch(toggleReadLoader(true));
    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: `/systemTypes?type=${type}&Event_Type_Filter=${eventTypeFilter}`,
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const saveOpportunityNote = (data) => {
  return ContactsApiProvider.put(`/contacts/${data.contactKey}/opportunities/${data.opportunityKey}`, data);
};

export const fetchVettingQuestions = (opportunityKey) => {
  return ContactsApiProvider.get(`/questionanswers/${opportunityKey}`);
};

export const fetchMlsData = (mlsId, state) => {
  let url = `/mlsSearch/${mlsId}/`;
  if (state) {
    url = `/mlsSearch/${mlsId}/${state}`;
  }
  return ContactsApiProvider.get(url);
};

export const saveContactOpportunityProperty = (contactKey, opportunityKey, opportunity) => {
  return ContactsApiProvider.put(`/contacts/${contactKey}/opportunities/${opportunityKey}`, opportunity);
};
